import { render, staticRenderFns } from "./GEmptyNotation.vue?vue&type=template&id=cb4a947c&"
import script from "./GEmptyNotation.vue?vue&type=script&lang=ts&"
export * from "./GEmptyNotation.vue?vue&type=script&lang=ts&"
import style0 from "./GEmptyNotation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports